
import React from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { FacebookShareButton, EmailShareButton, ViberShareButton, WhatsappShareButton, FacebookIcon, WhatsappIcon, ViberIcon, EmailIcon } from "react-share";
import colors from '../../colors';
import { texts } from '../../general/texts'

export const ShareCode = (props) => {
    const isOpen = props.isShareOpen
    const shareUrl = 'https://easypay.al/'
    const title = `Fito 500 ALL! \n Përshendetje! Unë jam duke përdorur EasyPay për të kryer gjithë pagesat dhe transfertat vendase, me kosto minimale dhe shumë thjesht! \n Regjistrohu dhe ti tani me kodin tim të referimit ${props.code} dhe fito 500 ALL pasi të kryesh gjithë hapat me sukses!` 

    return (
        <Dialog
            open={isOpen}
            onClose={props.handleClose}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '20px',
                    padding: '15px'
                },
            }}
        >
            <DialogTitle id="scroll-dialog-title" sx={{ textAlign: 'center', color: colors.orange, fontSize: '1.5rem', fontFamily: 'GerberaBold', borderBottom: '1px solid lightgray', marginBottom: 2 }} >{texts["title-invite-friend"]}</DialogTitle>
            <span style={{ color: colors.gray, fontSize: '0.9rem' }}>{texts['info-share-code']}</span>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 25 }}>
                <EmailShareButton url={shareUrl} title={title} style={{ marginRight: 10 }}>
                    <EmailIcon round size={50} />
                </EmailShareButton>
                <FacebookShareButton url={shareUrl} quote={title} style={{ marginRight: 10 }}>
                    <FacebookIcon round size={50} />
                </FacebookShareButton>
                <WhatsappShareButton url={shareUrl} title={title} style={{ marginRight: 10 }}>
                    <WhatsappIcon round size={50} />
                </WhatsappShareButton>
                <ViberShareButton url={shareUrl} quote={title} style={{ marginRight: 10 }}>
                    <ViberIcon round size={50} />
                </ViberShareButton>
            </div>
        </Dialog>
    )
}
export default ShareCode;